import fileTypeToIconMap from "Common/fileUtils/fileIcon";
import map from "lodash/map";
import reject from "lodash/reject";
import { SidebarMenuItem } from "../../Common";
import { FILE_KEY_REFIX, FOLDER_KEY_REFIX } from "../constants";
export const makeFolderItemKey = (id) => `${FOLDER_KEY_REFIX}_${id}`;
export const makeFileItemKey = (id) => `${FILE_KEY_REFIX}_${id}`;
export default (folders, allFiles, renderMenu) => map(reject(folders, "Deleted"), folder => {
    const key = makeFolderItemKey(folder.Id);
    const folderItem = new SidebarMenuItem(key, folder.Name, "icon-folder", undefined, folder, []);
    folderItem.actionElements = renderMenu ? [renderMenu(folder)] : undefined;
    if (!allFiles) {
        return folderItem;
    }
    const files = reject(allFiles[folder.Id], "Deleted");
    folderItem.subItems = map(files, (file) => {
        const fileItem = new SidebarMenuItem(makeFileItemKey(file.Id), file.FileName, fileTypeToIconMap[file.FileExtension || 1], undefined, file, undefined);
        return fileItem;
    });
    return folderItem;
});
